import { getDefaultOptions as t } from "./_lib/defaultOptions.js";
function a() {
  return Object.assign({}, t());
}
export {
  a as default,
  a as getDefaultOptions
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getDefaultOptions.js
// module id = 882
// module chunks = 67